import styled, { keyframes } from 'styled-components';
import { GRUNDFOS_BLUE, BLUE1, BLUE3, GREEN3, CARD_SHADOW, BORDER_LIGHT, RED3 } from '../../../constants/colors';
import { FONT_FAMILY, FONT_SIZE } from '../../../constants/fonts';
import { MEDIA } from '../../../constants/breakpoints';

export const DataVisualizationModal__Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(9, 40, 68, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 24px;

  ${MEDIA.MOBILE} {
    padding: 8px;
  }
`;

export const DataVisualizationModal__Root = styled.div`
  background: #ffffff;
  border-radius: 16px;
  box-shadow: ${CARD_SHADOW};
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 900px;
  max-height: 85vh;
  overflow: hidden;

  ${MEDIA.MOBILE} {
    max-width: 100%;
    max-height: 95vh;
    border-radius: 12px;
  }
`;

export const DataVisualizationModal__Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid ${BORDER_LIGHT};
  flex-shrink: 0;
`;

export const DataVisualizationModal__Title = styled.h2`
  margin: 0;
  font-family: ${FONT_FAMILY.BOLD};
  font-size: ${FONT_SIZE.LARGE};
  color: ${GRUNDFOS_BLUE};
`;

export const DataVisualizationModal__Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const DataVisualizationModal__ExportBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 20px;
  border: none;
  background: ${GREEN3};
  color: #ffffff;
  font-family: ${FONT_FAMILY.SEMI_BOLD};
  font-size: ${FONT_SIZE.SMALL};
  cursor: pointer;
  white-space: nowrap;
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }
`;

export const DataVisualizationModal__CloseBtn = styled.button`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  background: ${BLUE1};
  color: ${BLUE3};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  transition: background 0.2s ease;

  &:hover {
    background: #d0dde8;
  }
`;

export const DataVisualizationModal__Body = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  overflow: auto;

  /* Make the Plotly SVG fill the available space */
  .js-plotly-plot,
  .plotly,
  .plot-container {
    width: 100% !important;
    height: 100% !important;
  }

  ${MEDIA.MOBILE} {
    padding: 8px;
  }
`;

const spin = keyframes`
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
`;

export const DataVisualizationModal__Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 4px solid ${BLUE1};
  border-top-color: ${GRUNDFOS_BLUE};
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`;

export const DataVisualizationModal__Error = styled.p`
  color: ${RED3};
  font-family: ${FONT_FAMILY.REGULAR};
  font-size: ${FONT_SIZE.MEDIUM};
  text-align: center;
  padding: 32px;
`;
